import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const VALUE_FORMAT = 'YYYY-MM-DDTHH:mm';
const DISPLAY_FORMAT = 'YYYY/MM/DD HH:mm';

// A sign-up link's start or end, shown as YYYY/MM/DD HH:mm whatever the browser's locale — a
// native datetime-local input can only show the locale's own order. The value in and out is the
// same "2026-10-12T08:00" wall-clock string a datetime-local input gives, which the caller reads
// as Copenhagen time, so dayjs only displays and edits it and never converts a time zone.
const SignupLinkDateTimeField = ({ label, value, onChange }) => {
    const outerTheme = useTheme();
    // Both sign-up dialogs are dark, so the field and the calendar it opens are too.
    const darkTheme = useMemo(
        () => createTheme({ palette: { mode: 'dark', primary: outerTheme.palette.primary } }),
        [outerTheme],
    );
    const parsed = value ? dayjs(value) : null;

    return (
        <ThemeProvider theme={darkTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label={label}
                    value={parsed?.isValid() ? parsed : null}
                    onChange={(next) => onChange(next?.isValid() ? next.format(VALUE_FORMAT) : '')}
                    format={DISPLAY_FORMAT}
                    ampm={false}
                    slotProps={{ textField: { size: 'small' } }}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default SignupLinkDateTimeField;
